import { useLoginData } from "component/common/loginData";
import ConfirmationDialog from "component/dialogs/ConfirmationDialog";
import Button from "component/ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";
import {
  getCountryCode,
  getCurrentCountryName,
  getDatesFromTodayToBookingPlus15,
  getTimeZone,
} from "helper/appConstant";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  cancelSlots,
  getListOfVenueSlots,
  rescheduleSlotByVenue,
} from "store/slice/profile";

export default function CancelSlotsDialog({
  closeDialog,
  slotsData,
  orderData,
  closeCancelSlotDialog,
  actionType,
  fetchListing,
}) {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [slots, setSlots] = useState();
  const [message, SetMessage] = useState("");
  const userData = useLoginData();
  const [scheduleDates, setScheduleDate] = useState([]);
  const [rescheduleDate, setRescheduleDate] = useState("");
  const [rescheduleSlotData, setRescheduleSlotData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [showSchedulePage, setShowSchedulePage] = useState(false);
  const { venueBookingSlotsList } = useSelector((state) => state.profile);
  const dispatch = useDispatch();
  useEffect(() => {
    if (slotsData) {
      setSlots(JSON.parse(JSON.stringify(slotsData)));
    }
  }, [slotsData]);

  //   set dates
  useEffect(() => {
    if (orderData?.venueCardData?.length > 0) {
      const dates = getDatesFromTodayToBookingPlus15(
        orderData?.venueCardData[0]?.bookingDate
      );
      setScheduleDate(dates);
    }
  }, [orderData]);

  //   fetch booking date slots
  useEffect(() => {
    if (showSchedulePage && orderData?.venueCardData?.length > 0) {
      fetchVenueSlotsList(orderData?.venueCardData[0]?.bookingDate);
    }
  }, [showSchedulePage]);
  // fetch venue slots list
  const fetchVenueSlotsList = (date, slotStartTime) => {
    setLoader(true);
    setRescheduleDate(moment(date)?.format("YYYY-MM-DD"));
    const todayDate = moment(new Date())?.format("YYYY-MM-DD");
    const currentHour = String(new Date().getHours()).padStart(2, "0");
    const request = {
      language: "en",
      sportsName:
        orderData?.venueCardData?.length > 0
          ? orderData?.venueCardData[0]?.sportsName
          : "",
      venueId: orderData?.sellerId,
      country: getCurrentCountryName(),
      courtDetailId: null,
      slotStartTime: date == todayDate ? currentHour : null,
      slotDate: moment(date)?.format("YYYY-MM-DD"),
    };
    dispatch(getListOfVenueSlots(request, setLoader));
  };
  //   set reschedule slot data
  useEffect(() => {
    if (venueBookingSlotsList) {
      setRescheduleSlotData(
        JSON.parse(JSON.stringify(venueBookingSlotsList?.data))
      );
    }
  }, [venueBookingSlotsList]);
  //   handle close slots
  const handleCancelSlot = async () => {
    setButtonLoader(true);
    const request = {
      language: "en",
      orderIds: [orderData?.id],
      slotIds:
        slots?.length > 0
          ? slots[0]?.slots
            .filter((slot) => slot?.isSelected)
            .map((slot) => slot.slotId)
          : [],

      country: await getCountryCode(userData),
      isVenue: true,
      timeZone: getTimeZone(),
    };
    dispatch(cancelSlots(request, SetMessage, fetchListing, setButtonLoader));
  };
  //   handle success of reschedule slot
  const handleSuccess = (message) => {
    setShowConfirmationDialog(true);
    fetchListing();
    SetMessage(message);
  };
  //   handle reschedule slots
  const handleReschedule = async () => {
    const previousSlot =
      slots?.length > 0
        ? slots[0]?.slots.filter((slot) => slot?.isSelected)
        : [];
    const newSlot =
      rescheduleSlotData?.length > 0
        ? rescheduleSlotData[0]?.slots.filter((slot) => slot?.isSelected)
        : [];

    if (previousSlot?.length != newSlot?.length) {
      toast.error(`You can't add more than ${previousSlot?.length} slots`);
      return;
    }
    setButtonLoader(true);
    const request = {
      language: "en",
      venueId: orderData?.sellerId,
      sportsId: newSlot?.length > 0 ? newSlot[0]?.sportId : "",
      previousSlotIds: previousSlot?.map((slot) => slot.slotId),
      newSlotIds: newSlot?.map((slot) => slot.slotId),
      bookingDate: rescheduleDate,
      country: await getCountryCode(userData),
      bookingId: orderData?.id,
      newSlotPayment: newSlot?.map((item) => ({
        ...item?.paymentBreakdown,
        courtDetailId: item?.courtDetailId,
        courtName: item?.courtName,
        slotId: item?.slotId,
      })),
    };
    dispatch(rescheduleSlotByVenue(request, handleSuccess, setButtonLoader));
  };
  return (
    <div
      className="fixed inset-0 w-full bg-black/70 backdrop-blur-sm flex justify-center items-center z-50"
      onClick={(e) => {
        e.stopPropagation();
        closeDialog();
      }}
    >
      <div className="bg-white mx-3 p-2 md:p-4 w-full max-w-md rounded-lg shadow-lg">
        <div className="sticky top-0 bg-white z-10 border-b p-2 flex justify-between items-center">
          {showSchedulePage && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowSchedulePage(false);
              }}
              className="text-gray-500 hover:text-black text-xl"
            >
              <IoIosArrowBack />
            </button>
          )}{" "}
          <h2 className="text-lg font-semibold">{actionType} Slots</h2>
          <button
            onClick={closeDialog}
            className="text-gray-500 hover:text-black text-xl"
          >
            ✕
          </button>
        </div>
        {showSchedulePage ? (
          // schedules slots
          <div className="py-2">
            {buttonLoader && <FullPageLoader />}
            <div className="font-semibold">Select a Date</div>
            <p className="text-gray-400 text-sm">
              Pick a date to reschedule your slots
            </p>
            {/* dates */}
            <div className="flex gap-4 overflow-auto mt-3 thin-scrollbar">
              {scheduleDates?.map((date) => (
                <div
                  key={date}
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    fetchVenueSlotsList(date);
                  }}
                >
                  <div
                    className={`h-8 w-8 border-2 text-sm rounded-md ${rescheduleDate == date
                        ? "bg-highlight border-highlight text-white"
                        : "bg-white border-gray-300"
                      }  flex justify-center items-center`}
                  >
                    {moment(date)?.format("DD")}
                  </div>
                  <p
                    className={`text-center text-sm ${rescheduleDate == date
                        ? "text-highlight font-semibold"
                        : "text-gray-500"
                      } `}
                  >
                    {moment(date)?.format("ddd")}
                  </p>
                </div>
              ))}
            </div>
            {/* today date */}
            <div className="pt-4 text-sm">
              Available Slot for :{" "}
              <span className="text-highlight  font-semibold">
                {moment(rescheduleDate).format("DD/MM/YYYY")}
              </span>
            </div>
            {/* slots listing */}

            <div className=" mt-4">
              {loader ? (
                <div className="h-24 flex justify-center items-center">
                  <div className="h-10 w-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                rescheduleSlotData?.map((section, index) => (
                  <div key={index}>
                    <div className="flex justify-between ">
                      <div className="font-semibold">{section?.courtName}</div>
                      <div className="text-sm">
                        Available Space :{" "}
                        <span className="text-highlight  font-semibold">
                          {section?.availableSpace}
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-3  gap-3 mt-2">
                      {section?.slots.map((time, slotIndex) => (
                        <button
                          key={time?.slotId}
                          onClick={(e) => {
                            e.stopPropagation();
                            let temp = [...rescheduleSlotData];
                            temp[index].slots[slotIndex].isSelected =
                              !time?.isSelected;
                            setRescheduleSlotData(temp);
                          }}
                          disabled={!time?.slotAvailable}
                          className={`py-3 rounded-lg text-sm font-medium ${!time?.slotAvailable
                              ? "bg-gray-300 text-black cursor-not-allowed"
                              : time?.isSelected
                                ? "bg-green-500 text-white"
                                : "bg-sky-500 hover:bg-sky-600 text-white"
                            }`}
                        >
                          {`${time?.fromTime}-${time?.toTime}`}
                        </button>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        ) : (
          <div>
            <div className="py-3">
              Select Slots to {actionType?.toLowerCase()}
            </div>

            {slots?.map((slot, index) => {
              return (
                <div key={slot?.courtName}>
                  <div className="text-highlight font-semibold text-lg">
                    {slot?.courtName}
                  </div>

                  <div className="grid grid-cols-3  gap-3 mt-2">
                    {slot?.slots.map((time, slotIndex) => (
                      <button
                        key={time?.slotId}
                        onClick={(e) => {
                          e.stopPropagation();
                          let temp = [...slots];
                          temp[index].slots[slotIndex].isSelected =
                            !time?.isSelected;
                          setSlots(temp);
                        }}
                        disabled={!time?.venueWindowOpen}
                        className={`py-3 rounded-lg text-sm font-medium ${!time?.venueWindowOpen
                            ? "bg-gray-300 text-black cursor-not-allowed"
                            : time?.isSelected
                              ? "bg-red-500 text-white"
                              : "bg-sky-500 hover:bg-sky-600 text-white"
                          }`}
                      >
                        {`${time?.fromTime}-${time?.toTime}`}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <Button
          onClick={(e) => {
            e.stopPropagation();
            if (actionType == "Reschedule") {
              if (showSchedulePage) {
                handleReschedule();
              } else {
                setShowSchedulePage(true);
              }

              return;
            }
            setShowConfirmationDialog(true);
          }}
          fullWidth
          disabled={
            showSchedulePage
              ? rescheduleSlotData?.length > 0
                ? !rescheduleSlotData[0]?.slots?.some(
                  (item) => item?.isSelected
                )
                : false
              : slots?.length > 0
                ? !slots[0]?.slots?.some((item) => item?.isSelected)
                : false
          }
          size="md"
          className={"mt-4"}
          children={`${actionType} Slot`}
        />
      </div>
      {/* cancel slots confirmation dialog */}
      <ConfirmationDialog
        actionButtonName="Yes"
        isLoading={buttonLoader}
        onConfirm={() => handleCancelSlot()}
        closeDialog={() => {
          if (message) {
            closeDialog();
            closeCancelSlotDialog();
          } else {
            setShowConfirmationDialog(false);
          }
        }}
        buttonShow={message ? ["Cancel"] : ["actionButton", "Cancel"]}
        cancelButtonName={message ? "Ok" : "No"}
        isDialogOpen={{
          open: showConfirmationDialog,
          message: message
            ? message
            : "Are you sure you want to cancel selected slots?",
        }}
      />
    </div>
  );
}
